export default __webpack_public_path__ + "static/media/Mona_C01.6b235c34.mp4";